import { Link } from 'react-router-dom'

import Avatar from '../../../../../components/UI/Avatar'

import { getUserName } from '../../../../../helpers'

import { imagePrefix } from '../../../../../constants'

const MapCountryModalStudent = ({ student }) => {
  return (
    <div className="flex items-center w-full border-[#FFCA84] border-[1px] bg-[#FFF5EE] rounded-[6px] py-[8px] px-[10px]">
      <Avatar
        src={student.profile_picture ? `${imagePrefix}${student.profile_picture}` : ''}
        gender={student.gender}
        className="w-[36px] h-[36px] rounded-full object-cover mr-[12px]"
      />

      <div className="flex-1 flex flex-col">
        <span className="text-sm font-semibold text-[#F67443] font-Inter mb-[4px]">
          {getUserName(student, student.display_name, student.display_last_name)}
        </span>

        <span className="text-[10px] font-normal font-Inter text-[#F67443]">
          <span className="font-semibold">{student.total_classes}</span> Classes Together •{' '}
          <span className="font-semibold">{student.days_since_last_class}</span> Days ago Last Class
        </span>
      </div>

      <Link
        // to="/"
        className="mb-auto h-[22px] flex items-center justify-center rounded-[4px] border-[#F79009] border-[1px] px-[4px] text-[10px] font-Inter font-medium text-[#F79009] hover:text-[#F79009]"
      >
        See Profile
      </Link>
    </div>
  )
}

export default MapCountryModalStudent
